// UserContext.js
import React, { createContext, useState } from "react";

// Create the context
const UserContext = createContext();

// Create a provider component
const UserFormDataProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    phone:"",
    email:"",
    state:"",
    fleet:"",
    showJoinWaitList: false
  });

 // const [modalShow, setModalShow] = useState(false);

  /*
  firstName: data.first_name,
            lastName: data.last_name,
            companyName: data.companyName,
*/
  // Update user information
  // const updateUserFormData = (firstName, lastName, companyName,phone,email,state,fleet) => {
  //   setUserData({ firstName, lastName, companyName, phone, email, state, fleet});
  // };
  const updateUserFormData = (newData) => {
    setUserData((prevData) => ({
      ...prevData,
      ...newData, // Merge new values with existing data
    }));
  };

  return (
    <UserContext.Provider value={{ userData, updateUserFormData }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserFormDataProvider };
